/*
 * @Author: cxy
 * @Desc:
 * @Date: 2023-12-23 14:57:12
 * @LastEditTime: 2024-05-21 16:51:47
 */
import { reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import api from '@/api/'

export default () => {
  const _this = getCurrentInstance()
  const state = reactive({
    line_id: _this.$route.query.line_id,
    platformList: [], // 平台列表
    classifyList: [], // 分类列表
    authorList: [], // 发布者列表
    labelList: [], // 标签列表
  })

  onMounted(() => {
    // methods.getLabelArticle()
    methods.getPlatform()
    methods.getPublisher()
    methods.getArticleClassify()
  })

  const methods = {
    // 获取发布平台列表
    getPlatform: async function () {
      const res = await api.LineListNew()
      state.platformList = res.data
    },

    // 获取文章分类
    getArticleClassify: async function () {
      const res = await api.listClassify()
      state.classifyList = res?.data?.articleType
    },

    // 获取发布者
    getPublisher: async function () {
      const res = await api.listPublisher()
      state.authorList = res.data.articleAuthor
    },

    // 获取标签
    getLabel: async function (data = {}) {
      data = Object.assign({}, data, { status: 1, page: 1, per_page: 2000 })
      const res = await api.listLabel(data)
      state.labelList = res.data.label
    },

    // 获取标签（新）
    getLabelArticle: async function (data = {}) {
      data = Object.assign({}, data, { status: 1, line_id: state.line_id })
      const res = await api.listLabelArticle(data)
      state.labelList = res.data.label || []
    }
  }

  return {
    ...toRefs(state),
    ...methods
  }
}
